<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CNCT ParaOverride-3" id="_idParaDest-3"><img alt="" class="_idGenObjectAttribute-2" src="image/TitleJackSpades1.jpg"/> </p>
<p class="_-2-title ParaOverride-4"><span class="CharOverride-3">a Tale of suspense</span></p>
<p class="_-2-title ParaOverride-5"><span class="CharOverride-4">joyce carol oates</span></p>
<p class="BT ParaOverride-6"><img alt="" class="_idGenObjectAttribute-3" src="image/Mysteriouslogo.jpg"/></p>
<p class="BT ParaOverride-7">The Mysterious Press</p>
<p class="BT ParaOverride-7"><span class="CharOverride-5">an imprint of Grove/Atlantic, Inc.</span></p>
<p class="BT ParaOverride-7"><span class="CharOverride-2">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43522.vue?aca7eaa4